import styled from 'styled-components';

export const Container = styled.div<{ isSmaller?: boolean }>`
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  max-width: ${(props) => (props.isSmaller ? '860px' : '1160px')};
`;

export const WelcomingText = styled.p<{ isBold?: boolean }>`
  font-weight: 400;
  font-size: 14px;
  color: ${(props) => props.theme.colors['neutral-100']};
  margin-bottom: 24px;
  font-weight: ${(props) => (props.isBold ? 'bold' : '400')};
`;
